import { Component, OnDestroy } from '@angular/core';
import { GcFlyoutService } from '@core/services/gc-flyout.service';
import { MyApplicationForUi } from '@core/typings/application.typing';
import { Subscription } from 'rxjs';
import { ApplicantCommunicationService } from '../services/applicant-communications.service';
import { CommunicationFlyoutDetails, EmailAttachment } from '../typings/applicant-communications.typing';

@Component({
  selector: 'gc-communication-detail-flyout',
  templateUrl: './communication-detail-flyout.component.html',
  styleUrls: ['./communication-detail-flyout.component.scss']
})
export class CommunicationDetailFlyoutComponent implements OnDestroy {
  application: MyApplicationForUi;
  communication: CommunicationFlyoutDetails;
  sub = new Subscription();

  constructor (
    private gcFlyoutService: GcFlyoutService,
    private applicantCommunicationService: ApplicantCommunicationService
  ) {
    this.sub.add(this.gcFlyoutService.changesTo$('currentIdForFlyout').subscribe(() => {
      this.setHelpers();
    }));
  }

  get emailQueueId () {
    return +this.gcFlyoutService.currentIdForFlyout;
  }

  setHelpers () {
    this.communication = this.applicantCommunicationService.communicationFlyoutDetails[this.emailQueueId];
    this.application = this.applicantCommunicationService.currentFlyoutApp;
  }

  async downloadFile (
    attachment: EmailAttachment
  ) {
    await this.applicantCommunicationService.downloadFile(attachment.accessURL, attachment.fileName);
  }

  ngOnDestroy (): void {
    this.sub.unsubscribe();
  }
}
